class ClerkSession {
  // Shared with clerk-tracking.liquid, which fetches the ID from Clerk and stores it here.
  static STORAGE_KEY = 'visitor_id';

  /**
   * Returns the session visitor ID generated by clerk-tracking.liquid,
   * or an empty string when it is not available yet.
   * @returns {string}
   */
  static getVisitorId() {
    try {
      return window.clerk?.visitor || sessionStorage.getItem(ClerkSession.STORAGE_KEY) || '';
    } catch {
      return window.clerk?.visitor || '';
    }
  }
}
